import type { RecordingRefFragment } from '@spotify/confidence-graphql';

type MetricDisplay = {
  label: string;
  format: (metric: number | undefined) => string;
  userInteraction?: boolean;
};

export const getMetric = (
  metrics: RecordingRefFragment['metrics'] | undefined,
  key: string,
): number | undefined => {
  const value = metrics?.find(m => m.key === key)?.value?.value;
  return value ?? undefined;
};

export const formatMetric = (metric: number | undefined): string =>
  metric === undefined ? '-' : String(metric);

export const METRIC_DISPLAY: Record<string, MetricDisplay> = {
  clicks: { label: 'Clicks', format: formatMetric, userInteraction: true },
  inputs: { label: 'Inputs', format: formatMetric, userInteraction: true },
  rageClicks: {
    label: 'Rage clicks',
    format: formatMetric,
    userInteraction: true,
  },
  deadClicks: {
    label: 'Dead clicks',
    format: formatMetric,
    userInteraction: true,
  },
  scrollBacks: {
    label: 'Scroll backs',
    format: formatMetric,
    userInteraction: true,
  },
  tabUnfocuses: {
    label: 'Tab unfocuses',
    format: formatMetric,
    userInteraction: true,
  },
  errorMessages: { label: 'Error messages', format: formatMetric },
  networkRequestsFailed: { label: 'Failed requests', format: formatMetric },
  networkRequests: { label: 'Network requests', format: formatMetric },
  consoleLogs: { label: 'Console logs', format: formatMetric },
  consoleWarnings: { label: 'Console warnings', format: formatMetric },
  consoleErrors: { label: 'Console errors', format: formatMetric },
  routeChanges: {
    label: 'Route changes',
    format: formatMetric,
    userInteraction: true,
  },
};
